module.exports = __webpack_public_path__ + "media/เจ๋งแจ๋ว😂.e4898e00.mp3";